// extracted by mini-css-extract-plugin
export var md = "_4d-4";
export var semantic = "_4d-5";
export var sm = "_4d-3";
export var text = "_4d-6";
export var toggleInput = "_4d-0";
export var toggleSwitch = "_4d-1";
export var xs = "_4d-2";